













import { defineComponent } from "@vue/composition-api";
import { Notification } from "@scrile/api-provider/dist/api/NotificationsProvider";
import ScreenNamePrinter from "@/components/ScreenNamePrinter";
import NotificationItemView from "../../NotificationItemView.vue";

export default defineComponent({
  name: "NotificationNewUser",
  components: { ScreenNamePrinter, NotificationItemView },
  props: {
    notification: { type: Object as () => Notification, required: true },
  },
});
